import { render, staticRenderFns } from "./BindsOverlay.vue?vue&type=template&id=4e614f80&"
import script from "./BindsOverlay.vue?vue&type=script&lang=js&"
export * from "./BindsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BindsOverlay.vue?vue&type=style&index=0&id=4e614f80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports